import React from 'react';

import OverviewBatteryFeatures from './OverviewBatteryFeature';
import Searches from './Search';
import ClientAddBank from './ClientAddBank';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";
import ClientAddBattery from "./ClientAddBattery"
import ClientRightInstallation from "./ClientAllInstallation";
import ClientBatteryInfo from "./ClientBatteryInfo";
import ManualScroll from './ManualScroll'
import ClientAllPacks from './ClientAllPacks'
import ClientAllBatteries from "./ClientAllBatteries"
import ClientAllCells from "./ClientAllCells"
import ClientGraph from "./ClientGraph"
import ClientBankInfo from "./ClientBankInfo"
import ClientPackInfo from "./ClientPackInfo"

function ClientInstallation(){

  const { InstallationLinkSelection, updateInstallationLinkSelection } = useContext(MyContext);

  const [BankInfo, setBankInfo] = useState({
    id1: {
      name: "Central Office Pack",
      id: "2352kjjfa39919485hf248923g892h3",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  id2: {
      name: "Deco Park",
      id: "2352kjjfa39919485hf248923g892h6",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    }
  });

  const [PacksInfo, setPacksInfo] = useState({
    pack1: {
      name: "Pack 1",
      id: "2352kjjfa399194855",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  pack2: {
      name: "Pack 2",
      id: "2352kjjfa399194856",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    }
  });

  const [BatteryInfo, setBatteryInfo] = useState({
    battery1: {
      name: "Battery 1",
      id: "2352kjjfa392352kjjfa39",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  battery2: {
      name: "Battery 2",
      id: "2352kjjfa402352kjjfa40",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  battery3: {
      name: "Battery 3",
      id: "2352kjjfa402352kjjfa41",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  battery4: {
      name: "Battery 4",
      id: "2352kjjfa402352kjjfa42",
      type: "Z-Range",
      location: "Randburg",
      date: "15 June 2013",
    }
    
  });

  const [CellInfo, setCellInfo] = useState({
    CellInfo1: {
      name: "Cell 1",
      id: "2352kjjfa392352kjjfa43",
      voltage: "35",
      location: "Randburg",
      date: "14 June 2013",
    },  CellInfo2: {
      name: "Cell 2",
      id: "2352kjjfa402352kjjfa44",
      voltage: "36",
      location: "Randburg",
      date: "14 June 2013",
    },  CellInfo3: {
      name: "Cell 3",
      id: "2352kjjfa402352kjjfa45",
      voltage: "34",
      location: "Randburg",
      date: "14 June 2013",
    },  CellInfo4: {
      name: "Cell 4",
      id: "2352kjjfa402352kjjfa46",
      voltage: "35",
      location: "Randburg",
      date: "15 June 2013",
    }
    
  });
 

  let RightLink = () => {
    switch (InstallationLinkSelection) {
      case "Bank":
        return (
          <>
           <ClientAddBank />
          </>
        );
        break;

      case "Battery":
        return (
          <>
           <ClientAddBattery />
          </>
        );
        break;

      case "Installation":
        return (
          <>
            { 
              Object.entries(BankInfo).map(([id, item]) =>  (

              <div key={item.id}>
               <ClientRightInstallation  name={item.name} id={item.id} type={item.type} date={item.date} />
              </div>

                ))
            }
          </>
        );
        break;

        case "Information":
          return (
            <>
              <ClientBatteryInfo />
            </>
          );
          break;
          
          case "BankInformation":
          return (
            <>
              <ClientBankInfo />
            </>
          );
          break;

          case "PackInformation":
          return (
            <>
              <ClientPackInfo />
            </>
          );
          break;

          case "AllPacks":
            return (
              <>
                { 
                  Object.entries(PacksInfo).map(([id, item])  => (
    
                  <div key={item.id}>
                   <ClientAllPacks  name={item.name} id={item.id} />
                  </div>
    
                    ))
                }
              </>
            );
            break;

            case "AllBatteries":
            return (
              <>
                 { 
                  Object.entries(BatteryInfo).map(([id, item])  => (
    
                  <div key={item.id}>
                   <ClientAllBatteries  name={item.name} id={item.id} type={item.type} date={item.date} />
                  </div>
    
                    ))
                }
              </>
            );
            break;

            case "AllCells":
              return (
                <>
                   { 
                    Object.entries(CellInfo).map(([id, item])  => (
      
                    <div key={item.id}>
                     <ClientAllCells  name={item.name} id={item.id} type={item.type} date={item.date} voltage={item.voltage} />
                    </div>
      
                      ))
                  }
                </>
              );
              break;

              case "graphs":
                return (
                  <>

                  { 
             
               <ClientGraph  name={BankInfo.id1.name} id={BankInfo.id1.id} type={BankInfo.id1.type} />
             
                }
                  </>
                );
                break;
    }
  };

  //const bankInfoArray = Object.entries(BankInfo).map(([id, item]) => ({ id, ...item }));
 // const PacksInfoArray = Object.entries(PacksInfo).map(([id, item]) => ({ id, ...item }));

    return (
       
        <>
          <div className='OverviewContainer'  style={{paddingLeft: "240px", paddingRight: "80px"}}>
            <p className='dashboard_title'>Installation</p>

           <Searches />

           <div class="row">
            <div class="col-sm-9">
            
            {RightLink()}

            </div>

            
<div class="col-sm-3">
    <div className="card" style={{width: "18rem;"}}>
        <div className="card-body">
            

        <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        
                        <span class="material-symbols-rounded">offline_bolt</span>

                        </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Installation</h6> {/* <span style={{color:"#e5603c"}}>1 </span><span>Active Ticket </span>*/}
                        </div>
                    </div>
                    <div class="badge" style={{display: "flex"}}> 
                    <div class="material-symbols-rounded plantLink" >Settings</div>
                    
                  
                    </div>
                </div>
              {/*  <hr />
                <p><strong>Add Battery: </strong></p>*/}
   
<div className='d-flex'>
    
   <div className='smallInfo' style={{display: "flex",width:"100%"}}>
    
   {/* <span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>

   <div style={{width:"100%"}}>
 <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs", width:"100%"}} onClick={() => updateInstallationLinkSelection("Battery")}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>battery_plus</span> <span style={{paddingTop:"9px"}}>Battery Installation</span></span>
 </div>
    
   Add battery on existing bank 
     </span>
 */}
    
    </div>

   
  </div>
    <hr />
   
    <p><strong>Add Bank: </strong></p>
   
   <div className='d-flex'>
       
      <div className='smallInfo' style={{display: "flex", width:"100%"}}>
       
      {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>{/*<strong>Ticket</strong> */}
   
      <div>
    <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}} onClick={() => updateInstallationLinkSelection("Bank")}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>battery_5_bar</span> <span style={{paddingTop:"9px"}}>Add Battery Bank</span></span>
    </div>
     
        </span>
   
        </div>
    </div>

   

     {InstallationLinkSelection === "Installation" ? (
              ""
              ) : (
                <span>
 <hr />
<p><strong>All Installations: </strong></p>
   
   <div className='d-flex'>
       
      <div className='smallInfo' style={{display: "flex", width:"100%"}}>
       
      {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>{/*<strong>Ticket</strong> */}
   
      <div>
    <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}} onClick={() => updateInstallationLinkSelection("Installation")}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>offline_bolt</span> <span style={{paddingTop:"9px"}}>All Installed Banks</span></span>
    </div>
     
        </span>
       </div>
     </div>



                </span>

                
              )}

{InstallationLinkSelection === "AllCells" ? (
              <span>
              <hr />
             <p><strong>Cells Max/Min: </strong></p>
                
                <div className='d-flex'>
                    
                   <div className='smallInfo' style={{display: "flex", width:"100%"}}>
                    
                   {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>{/*<strong>Ticket</strong> */}
                
                   <div>
                


                  <div style={{display:"flex"}}>
                     <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Min Volt: </strong></span>

                     <p className='Font-primary currentCharging'>23V</p> 
                    </div>

                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Min Position: </strong></span>

                     <p className='Font-primary currentCharging'>Cell 3</p> 
                    </div>
                  </div>



                  <div style={{display:"flex"}}>
                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Max Volt: </strong></span>

                    <p className='Font-primary currentCharging'>45V</p> 
 
                    </div>

                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Max Position: </strong></span>

                     <p className='Font-primary currentCharging'>Cell 1</p> 
                    </div>
                  </div>


                 </div>
                  
                     </span>
                    </div>
                  </div>
             
             
             
                             </span>

                             

                             
              ) : (
                ""

                
              )}



              
{InstallationLinkSelection === "AllCells" ? (
              <span>
              <hr />
             <p><strong>Voltage Differents: </strong></p>
                
                <div className='d-flex'>
                    
                   <div className='smallInfo' style={{display: "flex", width:"100%"}}>
                    
                   {/*  <span class="material-symbols-rounded writing">support_agent</span> */}<span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>{/*<strong>Ticket</strong> */}
                
                   <div>
                


                   <p style={{fontSize:"30px", color:"#212529"}}><span class="material-symbols-rounded">battery_5_bar</span>
    <strong>10V</strong>
    </p>




                 </div>
                  
                     </span>
                    </div>
                  </div>
             
             
             
                             </span>

                             

                             
              ) : (
                ""

                
              )}
   
 
   
   


        </div>
    </div>


    {/*<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>
  <div className="card-body">
    <div style={{display: "flex"}}>
    <p className="card-title"><strong>Manuals</strong></p> <span className='info leftAling'><span class="material-symbols-rounded">more_horiz</span></span></div>

   
<div className='d-flex'>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">menu_book</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Release Note | Spec Sheet  </strong></span>

    
    </div>

    
  </div>
    <hr />

<ManualScroll />



  </div>
</div>*/}


</div>
           
          </div>
          
          </div>
        </>
    )
}

export default ClientInstallation;